import { isValidEmail } from '@/lib/utils/email';
import { isValidPhone } from '@/lib/utils/phone';

export type ContactPair = { phone: string; email: string };

/** Why the send is still shut — in the module's own voice, which says „du“. */
const HINTS = {
    missing: 'Gib eine Telefonnummer oder E-Mail-Adresse an – eins von beiden genügt.',
    phone: 'Bitte gib die Telefonnummer mit Vorwahl ein, z. B. 089 123456 oder +49 89 123456.',
    email: 'Bitte gib eine vollständige E-Mail-Adresse ein, z. B. name@beispiel.de.',
} as const;

/**
 * What keeps the send shut, in the order the fields stand — empty once it may
 * go. Either way of being reached is enough, so both blank is the one gap; but
 * whatever is typed has to be valid, even next to a valid other: the reply may
 * go either way, and a typo would lose it.
 */
export function contactHints({ phone, email }: ContactPair): string[] {
    const typedPhone = phone.trim();
    const typedEmail = email.trim();

    if (!typedPhone && !typedEmail) return [HINTS.missing];

    const hints: string[] = [];
    if (typedPhone && !isValidPhone(typedPhone)) hints.push(HINTS.phone);
    if (typedEmail && !isValidEmail(typedEmail)) hints.push(HINTS.email);

    return hints;
}
